"use client";

import React, { useEffect, useState } from "react";
import MutualFundsRight from "./MutualFundsRight";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import hdfc from "../../images/hdfc.png";
import axios from "axios";
import moment from "moment";
import NoDataFound from "../../components/NoDataFound";
import ImageLoading from "../../components/ImageLoading";
import Avatar from "react-avatar";

const MutualFunds = ({ id, mfid, setSingleMf, setMfId }) => {
  const token = localStorage.getItem("token");
  const options = {
    method: "GET",
    headers: { Authorization: token },
  };
  const params = useParams();
  // const { id,mfid } = params;
  const navigate = useNavigate();
  const [selectedMf, setSelectedMf] = useState(null);
  const [selectedInstitution, setSelectedInstitution] = useState("all");
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);

  const [keyInfo, setKeyInfo] = useState("");
  const [basicGraph, setBasicGraph] = useState("");
  const [longGraph, setLongGraph] = useState("");
  const [assetAllocationData, setAssetAllocationData] = useState("");
  const [peerListData, setPeerListData] = useState("");

  const handleMfClick = (mf) => {
    setSelectedMf(mf);
  };
  const handleDropdownChange = (event) => {
    setSelectedInstitution(event.target.value);
  };

  const getKeyInfo = async () => {
    setLoading(true);
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/key_info?isinno=${mfid}`,
        options
      );
      const res1 = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/get_nav?isinno=${mfid}`,
        options
      );
      const res2 = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/get_long_nav?isinno=${mfid}`,
        options
      );
      const res3 = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/asset_allocation?isinno=${mfid}`,
        options
      );
      const res4 = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/peer_list?isinno=${mfid}`,
        options
      );
      setKeyInfo(res?.data?.response);
      setBasicGraph(res1?.data?.response);
      setLongGraph(res2?.data?.response);
      setAssetAllocationData(res3?.data?.response);
      setPeerListData(res4?.data?.response);
      setNoData(false);
      setLoading(false);
    } catch (error) {
      setNoData(true);
      setLoading(false);
    }
  };

  const getBasicGraph = async () => {
    const res = await axios.request(
      `${process.env.REACT_APP_URL}//lender/v1/pulse_mf/get_nav?isinno=${mfid}`,
      options
    );
    setBasicGraph(res?.data?.response);
  };

  const getLongGraph = async () => {
    const res = await axios.request(
      `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/get_long_nav?isinno=${mfid}`,
      options
    );
    setLongGraph(res?.data?.response);
  };

  const getAssetAllocation = async () => {
    const res = await axios.request(
      `${process.env.REACT_APP_URL}/lender/v1/pulse_mf/asset_allocation?isinno=${mfid}`,
      options
    );
    setAssetAllocationData(res?.data?.response);
  };

  useEffect(() => {
    getKeyInfo();
    // getBasicGraph();
    // getLongGraph();
    // getAssetAllocation();
  }, [mfid]);

  const res = {
    MutualFunds: [
      {
        mutualfundName: "Parag Parikh Flexi Cap",
        xirr: "14",
        price: "235",
        currentValue: "35,220",
        institution: "grow",
        pe: "high",
      },
      {
        mutualfundName: "Quant Small Cap Fund",
        xirr: "28",
        price: "23",
        currentValue: "22,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        mutualfundName: "Kotak Infrastructure and Economic Reform Fund",
        xirr: "10",
        price: "55",
        currentValue: "18,920",
        institution: "grow",
        pe: "high",
      },
      {
        mutualfundName: "ICICI Prudential Value Discovery Fund",
        xirr: "25",
        price: "45",
        currentValue: "68,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        mutualfundName: "ICICI Prudential Focused Equity Fund",
        xirr: "40",
        price: "135",
        currentValue: "28,420",
        institution: "grow",
        pe: "high",
      },
      {
        mutualfundName: "DSP Healthcare Fund",
        xirr: "30",
        price: "25",
        currentValue: "48,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        mutualfundName: "Mirae Asset Great Consumer Fund",
        xirr: "10",
        price: "735",
        currentValue: "38,220",
        institution: "grow",
        pe: "high",
      },
      {
        mutualfundName: "Parag Parikh Flexi Cap",
        xirr: "10",
        price: "215",
        currentValue: "28,220",
        institution: "zerodha",
        pe: "low",
      },
      {
        mutualfundName: "Quant Small Cap Fund",
        xirr: "15",
        price: "205",
        currentValue: "19,220",
        institution: "grow",
        pe: "high",
      },
      {
        mutualfundName: "Kotak Infrastructure and Economic Reform Fund",
        xirr: "20",
        price: "265",
        currentValue: "18,210",
        institution: "grow",
        pe: "high",
      },
      {
        mutualfundName: "ICICI Prudential Value Discovery Fund",
        xirr: "9",
        price: "215",
        currentValue: "18,22",
        institution: "zerodha",
        pe: "low",
      },
      {
        mutualfundName: "Mirae Asset Great Consumer Fund",
        xirr: "15",
        price: "285",
        currentValue: "18,20",
        institution: "zerodha",
        pe: "high",
      },
    ],
  };

  useEffect(() => {
    // Set the initial selected stock to the first stock in the list
    if (res?.MutualFunds?.length > 0) {
      setSelectedMf(res.MutualFunds[0]);
    }
  }, []);

  return (
    <>
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {!noData && !loading && (
        <div className=" mt-4 w-full overflow-auto h-[calc(100vh-190px)] bg-white rounded">
          <div className="flex w-full h-[77vh]">
            {/* Left fixed width part */}
            <div className="w-[28%]">
              {/* Content for the left part */}
              <div
                className="inline-flex flex-row justify-start items-center gap-2 p-4 cursor-pointer"
                // onClick={() => navigate(`/individuals/${id}`)}
                onClick={() => {
                  setMfId("");
                  setSingleMf(false);
                }}
              >
                <FaArrowLeft size={"15px"} color="#00394D" />
                <p className="font-bold text-sm text-[#00394D]">Back</p>
              </div>
              <div className="border border-solid border-[#E6EBED] mx-4 rounded-lg">
                {keyInfo && (
                  <div className="p-4 flex flex-row items-center gap-4 w-full">
                    {/* <img src={hdfc} alt="" className="w-[45px] h-[45px]" /> */}
                    <Avatar
                      name={keyInfo?.fund_overview?.scheme_name.split(" ")[0]}
                      round={true}
                      size="50"
                    />
                    <div className="flex flex-col gap-2 w-full">
                      <h2
                        title={keyInfo?.fund_overview?.scheme_name}
                        className="text-lg font-semibold overflow-hidden whitespace-nowrap text-ellipsis w-[80%]"
                      >
                        {keyInfo?.fund_overview?.scheme_name}
                      </h2>
                      <div className="flex flex-row gap-4 items-center">
                        <p className="font-bold text-lg">
                          &#8377; {keyInfo?.fund_overview?.nav.toFixed(2)}
                        </p>
                        {/* <p className="text-xs font-semibold text-[#47B971]">+ 15.05</p>
                      <p className="text-xs font-semibold text-[#47B971]">+ 1.25%</p> */}
                      </div>
                      <p className="text-xs font-medium text-[#8b8b8b]">
                        As of{" "}
                        {moment(keyInfo?.fund_overview?.nav_date).calendar()}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="flex flex-col items-center gap-4 px-4">
                <div className="flex flex-col border border-solid border-[#E0E0E0] rounded-lg p-4 w-full">
                  <p className="font-semibold text-sm text-[#333333] mb-3">
                    About Company
                  </p>
                  <p className="font-medium text-sm text-[#8B8B8B]">
                    The Housing Development Finance Corporation Limited (HDFC)
                    was amongst the first to receive an &apos;in principle&apos;
                    approval from the Reserve Bank of India (RBI) to set up a
                    bank in the private sector. HDFC Bank is a publicly held
                    banking company, the bank was incorporated in August 1994 in
                    the name of &apos;HDFC Bank Limited&apos;, with its
                    registered office in Mumbai, India. It is engaged in
                    providing a range of banking and financial services
                    including retail banking, wholesale banking and treasury
                    operations. It is promoted by HDFC Ltd. which has 19.32%
                    stake as on September 30, 2020. Currently, HDFC Bank Ltd.
                    (HBL) is the largest private sector bank in India.
                  </p>
                </div>
              </div> */}
            </div>
            {/* Right flexible part */}
            <div className="w-[72%]">
              {/* Content for the right part */}
              <MutualFundsRight
                keyInfo={keyInfo}
                basicGraph={basicGraph}
                longGraph={longGraph}
                assetAllocationData={assetAllocationData}
                peerListData={peerListData}
                loading={loading}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MutualFunds;
